import { render, staticRenderFns } from "./PagamentosItens.vue?vue&type=template&id=0ca35a8f&scoped=true&"
import script from "./PagamentosItens.vue?vue&type=script&lang=js&"
export * from "./PagamentosItens.vue?vue&type=script&lang=js&"
import style0 from "./PagamentosItens.vue?vue&type=style&index=0&id=0ca35a8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca35a8f",
  null
  
)

export default component.exports